<router-outlet></router-outlet>

<router-outlet name="modal"></router-outlet>
